const mapLookupTypes = types => types.map( ( {
	id,
	name
} ) => ( {
	key: id,
	text: name,
	value: id
} ) );

export default mapLookupTypes;
